const featureList = [
    'shared-library',
    'projectComms',
    'ha',
    'teamHttpSecurity',
    'customCatalogs',
    'emailAlerts',
    'deviceGroups',
    'protectedInstance',
    'editorLimits',
    'customHostnames',
    'staticAssets',
    'instanceAutoSnapshot',
    'deviceAutoSnapshot',
    'bom',
    'teamBroker',
    'projectHistory',
    'npm',
    'gitIntegration',
    'instanceResources',
    'tables',
    'certifiedNodes',
    'assistantInlineCompletions',
    'generatedSnapshotDescription',
    'ffNodes',
    'rbacApplication'
]
const featureNames = {
    'shared-library': 'Team Library',
    projectComms: 'Project Nodes',
    ha: 'High Availability',
    teamHttpSecurity: 'Team-based Endpoint Security',
    customCatalogs: 'Custom NPM Catalogs',
    emailAlerts: 'Email Alerts',
    deviceGroups: 'Device Groups',
    protectedInstance: 'Protected Instances',
    editorLimits: 'API/Debug Length Limit',
    customHostnames: 'Custom Hostnames',
    staticAssets: 'Static Assets',
    instanceAutoSnapshot: 'Instance Auto Snapshot',
    deviceAutoSnapshot: 'Device Auto Snapshot',
    bom: 'Bill of Materials / Dependencies',
    teamBroker: 'Team Broker',
    projectHistory: 'Version History Timeline',
    npm: 'NPM Packages',
    gitIntegration: 'Git Integration',
    instanceResources: 'Instance Resources',
    tables: 'Tables',
    certifiedNodes: 'Certified Nodes',
    assistantInlineCompletions: 'Assistant Inline Code Completions',
    generatedSnapshotDescription: 'Generate Snapshot Descriptions',
    ffNodes: 'FlowFuse Exclusive Nodes',
    rbacApplication: 'Application-level RBAC'
}
module.exports = {
    featureList,
    featureNames
}
